/* global axios */
import ApiClient from './ApiClient';
import { resourcePath, requestConfig } from './lais/httpHelpers';

const storyPayload = payload => ({ story: payload });

const deleteConfig = payload => {
  const config = requestConfig();
  if (payload && Object.keys(payload).length) {
    config.data = storyPayload(payload);
  }
  return config;
};

class StoriesAPI extends ApiClient {
  constructor() {
    super('stories', { accountScoped: true });
  }

  get() {
    return axios.get(this.url, requestConfig());
  }

  create(payload = {}) {
    return axios.post(this.url, storyPayload(payload), requestConfig());
  }

  update(id, payload = {}) {
    return axios.patch(
      resourcePath(this.url, encodeURIComponent(id)),
      storyPayload(payload),
      requestConfig()
    );
  }

  archive(id, payload = {}) {
    return axios.post(
      resourcePath(this.url, encodeURIComponent(id), 'archive'),
      storyPayload(payload),
      requestConfig()
    );
  }

  delete(id, payload = {}) {
    return axios.delete(
      resourcePath(this.url, encodeURIComponent(id)),
      deleteConfig(payload)
    );
  }
}

export default new StoriesAPI();
